import React from 'react';
import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import { p16 } from '../../styles/typography';

const Host = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: ${gutter(4)};
`;

const LeftIcon = styled.div`
  margin: 4px ${gutter(2)} 0;
`;

const Content = styled.div`
  margin-right: auto;
`;

const Title = styled.div`
  ${p16};
  font-weight: 500;
  margin-bottom: 3px;
`;

const Copy = styled.div``;

const RightIcon = styled.div`
  align-self: center;
  margin: 0 ${gutter(2)};
`;

interface RulesItemProps {
  leftIcon: React.ReactNode;
  title: string;
  copy: string;
  rightIcon: React.ReactNode;
}

export const RulesItem = ({
  leftIcon,
  title,
  copy,
  rightIcon,
}: RulesItemProps) => {
  return (
    <Host>
      <LeftIcon>{leftIcon}</LeftIcon>
      <Content>
        <Title>{title}</Title>
        <Copy>{copy}</Copy>
      </Content>
      <RightIcon>{rightIcon}</RightIcon>
    </Host>
  );
};
